import React, { FC } from 'react';
import cn from 'classnames';
import { useLandingPageContext } from 'context/LandingPageContext';
import { MediumBanner } from '../../../../store/landing/types';
import MessageCardGroupBanner from '../MessageCardGroupBanner/MessageCardGroupBanner';
import MessageCardGroup from '../MessageCardGroup';
import LPDescription from '../../LPDescription/LPDescription';
import MultiLPDescription from '../../LPDescription/MultiLPDescription';
import styles from './MessageCardGroupBuilder.module.scss';

export interface MessageCardGroupBuilderProps {
  cards: MediumBanner[];
  messageCarGroupHeading?: string;
  messageCardGroupTitle?: string;
}

const MessageCardGroupBuilder: FC<MessageCardGroupBuilderProps> = ({
  cards,
  messageCarGroupHeading,
  messageCardGroupTitle,
}) => {
  const { theme } = useLandingPageContext();
  if (theme === 'shopify' && messageCardGroupTitle) {
    const markerIcon = `<svg  style="width: 100%;
                                height: 30%;
                                top: auto;
                                bottom: -20%;
                                position: absolute;
                                left: 0;
                                z-index: -1;
                                color: #fd6262;"
                      width="201" height="14" viewBox="0 0 201 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                    <path d="M3 10.5732C55.565 6.61382 168.107 -0.117058 197.753 4.63415" stroke="currentColor" stroke-width="6" stroke-linecap="round"></path>
                    </svg>`;
    const text = messageCardGroupTitle.replace(
      /\|([^|]+)\|/,
      `<span style="position: relative; display: inline-block; z-index: 2;">$1${markerIcon}</span>`,
    );
    return <LPDescription title={text} />;
  }

  const [messageCard] = cards;

  if (messageCard) {
    if (messageCard.miniBanner) {
      return (
        <div
          className={cn(styles.container, {
            [styles.textCenter]: !messageCard.layout || messageCard.layout === 'stacked',
          })}
        >
          {messageCardGroupTitle && <h3 className={styles.containerHeading}>{messageCardGroupTitle}</h3>}
          <div
            className={cn({
              [styles.cardsContainer]: !messageCard.layout || messageCard.layout === 'stacked',
              [styles.regularContainer]: messageCard.layout,
            })}
          >
            {cards.map((card) => (
              <MessageCardGroupBanner
                key={card.entryId}
                messageCardGroupTitle={messageCardGroupTitle}
                layout={card.layout}
                description={card.description1}
                heading={card.title}
                imageDesktop={card.miniBanner.bannerImageUrlDesktop}
                imageMobile={card.miniBanner.bannerImageUrlMobile}
                bannerImagePosition={card.bannerImagePosition}
                references={card.references}
                cardsCount={cards.length}
              />
            ))}
          </div>
        </div>
      );
    }
    if (messageCard.references.length > 0) {
      return (
        <>
          {messageCard.references.map((reference) => (
            <MessageCardGroup
              key={reference.entryId}
              buttonItem={reference.buttonItem}
              heading1={messageCardGroupTitle}
              heading2={messageCarGroupHeading}
              description={messageCard.description1}
              title={messageCard.title}
            />
          ))}
        </>
      );
    }

    if (!messageCard.miniBanner && messageCard.references.length === 0 && cards.length === 1) {
      return (
        <LPDescription
          heading1={messageCardGroupTitle}
          heading2={messageCarGroupHeading}
          title={messageCard.title}
          description={messageCard.description1}
          description1Preview={messageCard.description1Preview}
          description2={messageCard.description2}
          description2Preview={messageCard.description2Preview}
          cardsCount={cards.length}
        />
      );
    }

    if (!messageCard.miniBanner && messageCard.references.length === 0 && cards.length > 1) {
      return <MultiLPDescription cards={cards} />;
    }
  }

  return null;
};

export default MessageCardGroupBuilder;
